<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content signup">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-12" style="text-align: center">
                    <img
                      class="aligncenter size-full hc-managed-firewall-img"
                      src="/static/assets/images/error.png"
                      style="max-width: 200px"
                    />
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <!-- <h1
                      class="wow fadeIn"
                      style="
                        display: block;
                        margin: 30px auto;
                        text-align: center;
                        color: #ff4d64;
                      "
                    >
                      Coming Soon.
                    </h1> -->
                    <h2
                      class="wow fadeIn"
                      style="
                        display: block;
                        margin: 30px auto;
                        text-align: center;
                        font-size: 30px;
                        line-height: 30px;
                        color: #f46275;
                      "
                    >
                      {{ errorMessage }}
                    </h2>
                    <h3
                      class="wow fadeIn"
                      style="
                        display: block;
                        margin: 30px auto;
                        text-align: center;
                        font-size: 26px;
                        line-height: 30px;
                        color: rgb(130, 130, 130);
                      "
                    >
                      {{ suberrorMessage }}
                    </h3>
                    <h3
                      class="wow fadeIn"
                      style="
                        display: block;
                        margin: 30px auto;
                        text-align: center;
                        font-size: 26px;
                        line-height: 30px;
                        color: rgb(130, 130, 130);
                      "
                    >
                      {{ subsuberrorMessage }}
                    </h3>
                  </div>
                  <div class="col-sm-12">
                    <div role="form" class="wpcf7" dir="ltr" lang="en-US">
                      <div class="screen-reader-response"></div>
                      <form
                        @submit.prevent="submitForm"
                        id="contactUsForm"
                        action="#"
                        method="post"
                        class="wpcf7-form"
                        novalidate="novalidate"
                      >
                        <div class="mc4wp-form-fields">
                          <div class="newsletter-hostcluester" style="max-width: max-content;margin: 0 auto;">
                            <input
                              v-model="newsletteremail"
                              name="email"
                              placeholder="Insert your email"
                              required
                              type="email"
                            />
                            <input
                              value="Send"
                              id="formsubmit"
                              type="button"
                              v-on:click="subscrbe"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p
                      v-if="newsletteremailError"
                      style="
                        color: #f78a8a;
                        padding: 14px 0px;
                        margin-bottom: -15px;
                        text-align: center;
                      "
                    >
                      Invalid email address. Please enter valid email address
                    </p>
                    <p
                      v-if="newsletteremailFailed"
                      style="
                        color: #f78a8a;
                        padding: 14px 0px;
                        margin-bottom: -15px;
                        text-align: center;
                      "
                    >
                      Cannot subscribe to newsletter. Please try again.
                    </p>
                    <p
                      v-if="newsletteremailSuccess"
                      style="
                        color: #81da9e;
                        padding: 14px 0px;
                        margin-bottom: -15px;
                        text-align: center;
                      "
                    >
                      Successfully Subscribed!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
var axios = require("axios");

const config = {
  headers: {
    "Content-Type": "application/json",
    Host: "https://staging.clearmeout.com",
    Authorization:
      "Basic a2V5OjAwZjNkOTRjZWMyOGEzMWIxMDdlNzJjN2E2ZmY3MGU0LXVzMg==",
  },
};
export default {
  name: "signup",
  data() {
    return {
      msg: "Clear Me Out - Sign Up",
      errorMessage: "",
      suberrorMessage: "",
      subsuberrorMessage: "",
      countries: [
        { name: "Afghanistan", code: "AF" },
        { name: "Åland Islands", code: "AX" },
        { name: "Albania", code: "AL" },
        { name: "Algeria", code: "DZ" },
        { name: "American Samoa", code: "AS" },
        { name: "AndorrA", code: "AD" },
        { name: "Angola", code: "AO" },
        { name: "Anguilla", code: "AI" },
        { name: "Antarctica", code: "AQ" },
        { name: "Antigua and Barbuda", code: "AG" },
        { name: "Argentina", code: "AR" },
        { name: "Armenia", code: "AM" },
        { name: "Aruba", code: "AW" },
        { name: "Australia", code: "AU" },
        { name: "Austria", code: "AT" },
        { name: "Azerbaijan", code: "AZ" },
        { name: "Bahamas", code: "BS" },
        { name: "Bahrain", code: "BH" },
        { name: "Bangladesh", code: "BD" },
        { name: "Barbados", code: "BB" },
        { name: "Belarus", code: "BY" },
        { name: "Belgium", code: "BE" },
        { name: "Belize", code: "BZ" },
        { name: "Benin", code: "BJ" },
        { name: "Bermuda", code: "BM" },
        { name: "Bhutan", code: "BT" },
        { name: "Bolivia", code: "BO" },
        { name: "Bosnia and Herzegovina", code: "BA" },
        { name: "Botswana", code: "BW" },
        { name: "Bouvet Island", code: "BV" },
        { name: "Brazil", code: "BR" },
        { name: "British Indian Ocean Territory", code: "IO" },
        { name: "Brunei Darussalam", code: "BN" },
        { name: "Bulgaria", code: "BG" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Burundi", code: "BI" },
        { name: "Cambodia", code: "KH" },
        { name: "Cameroon", code: "CM" },
        { name: "Canada", code: "CA" },
        { name: "Cape Verde", code: "CV" },
        { name: "Cayman Islands", code: "KY" },
        { name: "Central African Republic", code: "CF" },
        { name: "Chad", code: "TD" },
        { name: "Chile", code: "CL" },
        { name: "China", code: "CN" },
        { name: "Christmas Island", code: "CX" },
        { name: "Cocos (Keeling) Islands", code: "CC" },
        { name: "Colombia", code: "CO" },
        { name: "Comoros", code: "KM" },
        { name: "Congo", code: "CG" },
        { name: "Congo, The Democratic Republic of the", code: "CD" },
        { name: "Cook Islands", code: "CK" },
        { name: "Costa Rica", code: "CR" },
        { name: "Cote D'Ivoire", code: "CI" },
        { name: "Croatia", code: "HR" },
        { name: "Cuba", code: "CU" },
        { name: "Cyprus", code: "CY" },
        { name: "Czech Republic", code: "CZ" },
        { name: "Denmark", code: "DK" },
        { name: "Djibouti", code: "DJ" },
        { name: "Dominica", code: "DM" },
        { name: "Dominican Republic", code: "DO" },
        { name: "Ecuador", code: "EC" },
        { name: "Egypt", code: "EG" },
        { name: "El Salvador", code: "SV" },
        { name: "Equatorial Guinea", code: "GQ" },
        { name: "Eritrea", code: "ER" },
        { name: "Estonia", code: "EE" },
        { name: "Ethiopia", code: "ET" },
        { name: "Falkland Islands (Malvinas)", code: "FK" },
        { name: "Faroe Islands", code: "FO" },
        { name: "Fiji", code: "FJ" },
        { name: "Finland", code: "FI" },
        { name: "France", code: "FR" },
        { name: "French Guiana", code: "GF" },
        { name: "French Polynesia", code: "PF" },
        { name: "French Southern Territories", code: "TF" },
        { name: "Gabon", code: "GA" },
        { name: "Gambia", code: "GM" },
        { name: "Georgia", code: "GE" },
        { name: "Germany", code: "DE" },
        { name: "Ghana", code: "GH" },
        { name: "Gibraltar", code: "GI" },
        { name: "Greece", code: "GR" },
        { name: "Greenland", code: "GL" },
        { name: "Grenada", code: "GD" },
        { name: "Guadeloupe", code: "GP" },
        { name: "Guam", code: "GU" },
        { name: "Guatemala", code: "GT" },
        { name: "Guernsey", code: "GG" },
        { name: "Guinea", code: "GN" },
        { name: "Guinea-Bissau", code: "GW" },
        { name: "Guyana", code: "GY" },
        { name: "Haiti", code: "HT" },
        { name: "Heard Island and Mcdonald Islands", code: "HM" },
        { name: "Holy See (Vatican City State)", code: "VA" },
        { name: "Honduras", code: "HN" },
        { name: "Hong Kong", code: "HK" },
        { name: "Hungary", code: "HU" },
        { name: "Iceland", code: "IS" },
        { name: "India", code: "IN" },
        { name: "Indonesia", code: "ID" },
        { name: "Iran, Islamic Republic Of", code: "IR" },
        { name: "Iraq", code: "IQ" },
        { name: "Ireland", code: "IE" },
        { name: "Isle of Man", code: "IM" },
        { name: "Israel", code: "IL" },
        { name: "Italy", code: "IT" },
        { name: "Jamaica", code: "JM" },
        { name: "Japan", code: "JP" },
        { name: "Jersey", code: "JE" },
        { name: "Jordan", code: "JO" },
        { name: "Kazakhstan", code: "KZ" },
        { name: "Kenya", code: "KE" },
        { name: "Kiribati", code: "KI" },
        { name: "Korea, Democratic People'S Republic of", code: "KP" },
        { name: "Korea, Republic of", code: "KR" },
        { name: "Kuwait", code: "KW" },
        { name: "Kyrgyzstan", code: "KG" },
        { name: "Lao People'S Democratic Republic", code: "LA" },
        { name: "Latvia", code: "LV" },
        { name: "Lebanon", code: "LB" },
        { name: "Lesotho", code: "LS" },
        { name: "Liberia", code: "LR" },
        { name: "Libyan Arab Jamahiriya", code: "LY" },
        { name: "Liechtenstein", code: "LI" },
        { name: "Lithuania", code: "LT" },
        { name: "Luxembourg", code: "LU" },
        { name: "Macao", code: "MO" },
        { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
        { name: "Madagascar", code: "MG" },
        { name: "Malawi", code: "MW" },
        { name: "Malaysia", code: "MY" },
        { name: "Maldives", code: "MV" },
        { name: "Mali", code: "ML" },
        { name: "Malta", code: "MT" },
        { name: "Marshall Islands", code: "MH" },
        { name: "Martinique", code: "MQ" },
        { name: "Mauritania", code: "MR" },
        { name: "Mauritius", code: "MU" },
        { name: "Mayotte", code: "YT" },
        { name: "Mexico", code: "MX" },
        { name: "Micronesia, Federated States of", code: "FM" },
        { name: "Moldova, Republic of", code: "MD" },
        { name: "Monaco", code: "MC" },
        { name: "Mongolia", code: "MN" },
        { name: "Montserrat", code: "MS" },
        { name: "Morocco", code: "MA" },
        { name: "Mozambique", code: "MZ" },
        { name: "Myanmar", code: "MM" },
        { name: "Namibia", code: "NA" },
        { name: "Nauru", code: "NR" },
        { name: "Nepal", code: "NP" },
        { name: "Netherlands", code: "NL" },
        { name: "Netherlands Antilles", code: "AN" },
        { name: "New Caledonia", code: "NC" },
        { name: "New Zealand", code: "NZ" },
        { name: "Nicaragua", code: "NI" },
        { name: "Niger", code: "NE" },
        { name: "Nigeria", code: "NG" },
        { name: "Niue", code: "NU" },
        { name: "Norfolk Island", code: "NF" },
        { name: "Northern Mariana Islands", code: "MP" },
        { name: "Norway", code: "NO" },
        { name: "Oman", code: "OM" },
        { name: "Pakistan", code: "PK" },
        { name: "Palau", code: "PW" },
        { name: "Palestinian Territory, Occupied", code: "PS" },
        { name: "Panama", code: "PA" },
        { name: "Papua New Guinea", code: "PG" },
        { name: "Paraguay", code: "PY" },
        { name: "Peru", code: "PE" },
        { name: "Philippines", code: "PH" },
        { name: "Pitcairn", code: "PN" },
        { name: "Poland", code: "PL" },
        { name: "Portugal", code: "PT" },
        { name: "Puerto Rico", code: "PR" },
        { name: "Qatar", code: "QA" },
        { name: "Reunion", code: "RE" },
        { name: "Romania", code: "RO" },
        { name: "Russian Federation", code: "RU" },
        { name: "RWANDA", code: "RW" },
        { name: "Saint Helena", code: "SH" },
        { name: "Saint Kitts and Nevis", code: "KN" },
        { name: "Saint Lucia", code: "LC" },
        { name: "Saint Pierre and Miquelon", code: "PM" },
        { name: "Saint Vincent and the Grenadines", code: "VC" },
        { name: "Samoa", code: "WS" },
        { name: "San Marino", code: "SM" },
        { name: "Sao Tome and Principe", code: "ST" },
        { name: "Saudi Arabia", code: "SA" },
        { name: "Senegal", code: "SN" },
        { name: "Serbia and Montenegro", code: "CS" },
        { name: "Seychelles", code: "SC" },
        { name: "Sierra Leone", code: "SL" },
        { name: "Singapore", code: "SG" },
        { name: "Slovakia", code: "SK" },
        { name: "Slovenia", code: "SI" },
        { name: "Solomon Islands", code: "SB" },
        { name: "Somalia", code: "SO" },
        { name: "South Africa", code: "ZA" },
        { name: "South Georgia and the South Sandwich Islands", code: "GS" },
        { name: "Spain", code: "ES" },
        { name: "Sri Lanka", code: "LK" },
        { name: "Sudan", code: "SD" },
        { name: "Suriname", code: "SR" },
        { name: "Svalbard and Jan Mayen", code: "SJ" },
        { name: "Swaziland", code: "SZ" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Syrian Arab Republic", code: "SY" },
        { name: "Taiwan, Province of China", code: "TW" },
        { name: "Tajikistan", code: "TJ" },
        { name: "Tanzania, United Republic of", code: "TZ" },
        { name: "Thailand", code: "TH" },
        { name: "Timor-Leste", code: "TL" },
        { name: "Togo", code: "TG" },
        { name: "Tokelau", code: "TK" },
        { name: "Tonga", code: "TO" },
        { name: "Trinidad and Tobago", code: "TT" },
        { name: "Tunisia", code: "TN" },
        { name: "Turkey", code: "TR" },
        { name: "Turkmenistan", code: "TM" },
        { name: "Turks and Caicos Islands", code: "TC" },
        { name: "Tuvalu", code: "TV" },
        { name: "Uganda", code: "UG" },
        { name: "Ukraine", code: "UA" },
        { name: "United Arab Emirates", code: "AE" },
        { name: "United Kingdom", code: "GB" },
        { name: "United States", code: "US" },
        { name: "United States Minor Outlying Islands", code: "UM" },
        { name: "Uruguay", code: "UY" },
        { name: "Uzbekistan", code: "UZ" },
        { name: "Vanuatu", code: "VU" },
        { name: "Venezuela", code: "VE" },
        { name: "Viet Nam", code: "VN" },
        { name: "Virgin Islands, British", code: "VG" },
        { name: "Virgin Islands, U.S.", code: "VI" },
        { name: "Wallis and Futuna", code: "WF" },
        { name: "Western Sahara", code: "EH" },
        { name: "Yemen", code: "YE" },
        { name: "Zambia", code: "ZM" },
        { name: "Zimbabwe", code: "ZW" },
      ],
      date: new Date().toISOString().substr(0, 4),
      newsletteremail: "",
      newsletteremailError: false,
      newsletteremailSuccess: false,
      newsletteremailFailed: false,
      info: null,
    };
  },
  methods: {
    subscrbe: function (e) {
      this.newsletteremailSuccess = false;

      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(String(this.newsletteremail).toLowerCase())) {
        this.newsletteremailError = true;
        return;
      }

      const $this = this;
      this.newsletteremailError = false;

      jQuery
        .post("https://staging.clearmeout.com/newsletter.php", {
          email: this.newsletteremail,
        })
        .done(function (data) {
          $this.newsletteremail = "";
          $this.newsletteremailSuccess = true;

          // setTimeout(() => {
          //   $this.newsletteremailSuccess = false;
          // }, 5000);
        })
        .fail(function (xhr, status, error) {
          $this.newsletteremailFailed = true;
          $this.newsletteremail = "";
          // setTimeout(() => {
          //   $this.newsletteremailFailed = false;
          // }, 5000);
        });
    },
  },
  mounted() {
    const $this = this;

    jQuery.get(
      "http://ipinfo.io/?token=55420d956e874a",
      function (response) {
        console.log("response", response);
        $this.errorMessage = "";

        if (`${response.country}`.toUpperCase() === "NZ") {
          $this.errorMessage =
            "Sorry, due to high demand that exceeds our service capacity, we are unable to provide your requested service for the time being.";
          $this.suberrorMessage =
            "In urgency, you may request for and fill in a Queue Service Request Form to get the intended service on a priority basis.";
          $this.subsuberrorMessage =
            "To get a notification on the re-availability of our service, please subscribe. ";
        } else {
          // eslint-disable-next-line array-callback-return
          $this.countries.filter((country) => {
            if (country.code === `${response.country}`.toUpperCase()) {
              $this.errorMessage = `Sorry, Clear Me Out services are currently not available for ${country.name}.`;
              $this.suberrorMessage = `To get to know about the commencement of Clear Me Out services to ${country.name}, please subscribe.`;
            }
          });
        }
      },
      "jsonp"
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.signup .mc4wp-form-fields input[type="email"] {
  background: rgba(255, 255, 255, 1) none repeat scroll 0 0;
  color: #252525;
  font-size: 15px;
  padding: 15px 25px;
  outline: 0;
  float: left;
  border-radius: 10px 0px 0px 10px;
  font-weight: 400;
  width: 300px;
}

.signup .mc4wp-form-fields input[type="submit"], .signup .mc4wp-form-fields #formsubmit {
  color: rgb(255, 255, 255);
    font-size: 15px;
    background: #81DAA0;
    padding: 16px 35px;
    border: 0;
    outline: 0;
    border-radius: 0px 10px 10px 0px;
    font-weight: 700;
    text-transform: uppercase;
    transition: all 250ms ease;
    -webkit-transition: all 250ms ease;
    -ms-transition: all 250ms ease;
    width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/signup.vue